import sigliveServiceV2 from 'Service/sigliveServiceV2';

const getOneRoleAccess = async (id) => {
  const { data } = await sigliveServiceV2({ method: 'GET', url: `/access/role/${id}` });

  return data?.data?.role;
};

export default getOneRoleAccess;
